// 헝지우 기공소 셀프 온보딩 API 클라이언트
// BE: china-inapi /lab-orders/onboarding (SPEC-CHINA-HENGJIU-SELF-ONBOARD-001)
//
// 흐름: 클레임(factoryId+공개키) 제출 → PENDING → 헝지우 ERP 连接测试 서명 검증 통과 시 자동 활성.
// factoryId 연결을 신래안이 하던 관문①을 대체한다. 수기 경로(거래처 관리)는 백업으로 유지.

import { chinaInapi } from './chinaInapi';

const BASE = '/lab-orders/onboarding';

/**
 * 온보딩 상태 조회.
 *
 * companyId 를 주면 **대상 기공소**의 상태를 조회한다(REQ-HP-006, 대리 경로).
 * 운영자와 관계된 제조사만 허용되며, 기공소가 남의 companyId 를 넣으면 BE 가 403 을 낸다.
 * 생략하면 종전대로 로그인 계정 소속 회사의 상태다.
 *
 * @param {{ companyId?: string }} [options]
 * @returns {Promise<{state:'none'|'pending'|'active', factoryId?:string, signatureFailCount?:number, lastFailAt?:string|null}>}
 */
export async function getOnboardingStatus(options = {}) {
  const params = {};
  if (options.companyId) params.companyId = options.companyId;
  const res = await chinaInapi.get(`${BASE}/status`, { params });
  return res.data;
}

/**
 * 클레임 등록/재제출 — status=PENDING 생성. 같은 회사의 기존 PENDING 은 키 교체로 처리(BE).
 * @param {{ factoryId: string, publicKeyPem: string }} payload
 */
export function createOnboardingClaim(payload) {
  return chinaInapi.post(`${BASE}/claims`, payload);
}
